import { fetchWithAuth } from '../helpers';

const getAll = async () => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/lesson_diaries/`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getByMonth = async (year: number, month: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/lesson_diaries/month/${year}/${month}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const create = async (formData: FormData) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/lesson_diaries/`, {
    method: 'POST',
    headers: { "ngrok-skip-browser-warning": "69420" },
    body: formData
  });
  return handleResponse(response);
};

const update = async (id: number, formData: FormData) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/lesson_diaries/${id}`, {
    method: 'PUT',
    headers: { "ngrok-skip-browser-warning": "69420" },
    body: formData
  });
  return handleResponse(response);
};

const remove = async (id: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/lesson_diaries/${id}`, {
    method: 'DELETE',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const createFlashcardSet = async (diaryId: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/lesson_diaries/${diaryId}/flashcard-set`, {
    method: 'POST',
    headers: { 
      "ngrok-skip-browser-warning": "69420",
      "Content-Type": "application/json"
    },
  });
  return handleResponse(response);
};

const updateFlashcardSet = async (diaryId: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/lesson_diaries/${diaryId}/flashcard-set`, {
    method: 'PUT',
    headers: { 
      "ngrok-skip-browser-warning": "69420",
      "Content-Type": "application/json"
    },
  });
  return handleResponse(response);
};

const handleResponse = (response: Response) => {
  return response.text().then((text: string) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
};

export const lessonDiaryService = {
  getAll,
  getByMonth,
  create,
  update,
  remove,
  createFlashcardSet,
  updateFlashcardSet,
};
